import { Controller } from "remult";

@Controller("opportunity-population-methods")
export class OpportunityPopulationMethods {}






